import React from 'react';
import IncomeResolutionWorkspace from './IncomeResolutionWorkspace';

/** 수입결의등록 */
export default function IncomeResolutionRegister() {
  return <IncomeResolutionWorkspace screenMode="register" />;
}
